import { z } from 'zod';

export const Address = z.string().min(1, {
  message: 'This field is required. Please enter a valid U.S. address.',
});

export type Address = z.infer<typeof Address>;
